export default {
    jsonUrl: '/store/glasses.json',
    glassesBaseUrl: 'https://www.eschenbach-eyewear.com/wp-content/uploads/glasses/',
    language: 'de',
    itemsperpage: 30,
    hideTitles: false,
    checkFilters: {},
    sorting: 'model_down',
    useSessionStore: false,
    hideBrandLabels: false,
    preferredView: ""
}